module.exports = __webpack_public_path__ + "static/media/triangle-a.4dae2f82.webp";